import React, { Component, Fragment } from 'react';
import { attackStr, attackFlags, getCancels, getMot,getHitEffects, computeRecovery} from './utils'
import ReqList from './ReqList'




export default class AttackInfoPanel extends Component {
  render(){
    var {data,selectedMot,selectedMotId, selectMot} = this.props;
    if(selectedMot.startup == 0) return null;
    var hitEffects = getHitEffects(data,selectedMot.hitEffectId);
    var [ selectedframes, selectedId ] = computeRecovery(data,selectedMot);
    var _this = this;
    function hitreactionElement(animations,index,title){

      var motId = animations[1][index];
      if(motId == 0) return null;
      var mot = getMot(data,motId)
      var [ frames, id ] = computeRecovery(data,mot);
      var recoveryMot = getMot(data,id)
      var adv = frames-selectedframes+selectedMot.startup
      if(adv > 0) adv = "+"+adv
      return <tr key={index}>
        <th>{title}</th>
        <th>{adv}</th>
        <td><a onClick={() =>selectMot(motId)}>#{motId.toString(16)} {mot.name}</a></td>
        <td><a onClick={() =>selectMot(id)}>#{id.toString(16)} {recoveryMot.name}</a></td>
      </tr>
    }
    function hiteffectElement(el,i){

      var tmp = [];
      var animations = data.hitAnimations[el.hitEffect.hitAnimation];
      tmp.push(hitreactionElement(animations,0,"STAND HIT"))
      //todonojuggle
      if(attackFlags[selectedMot.attackFlags] != "HIGH") tmp.push(hitreactionElement(animations,1,"CROUCH HIT"))
      if(animations[1][2] != animations[1][0] && animations[1][2] != 0) tmp.push(hitreactionElement(animations,2,"STAND C-HIT"))
      if(attackFlags[selectedMot.attackFlags] != "HIGH" && animations[1][3] != animations[1][0] && animations[1][3] != 0) tmp.push(hitreactionElement(animations,2,"CROUCH C-HIT"))
      if(attackFlags[selectedMot.attackFlags] != "LOW")  tmp.push(hitreactionElement(animations,10,"STAND GUARD"))
      if(attackFlags[selectedMot.attackFlags] == "LOW"||attackFlags[selectedMot.attackFlags] == "SPMID") tmp.push(hitreactionElement(animations,11,"CROUCH GUARD"))
      return <Fragment key={i}>
      <tr className="alt">
        <th colSpan="2">
        Damage:{el.hitEffect.damage}
        <ReqList {..._this.props} startIndex={el.hitEffect.conditionIndex}/>
        </th>
        <th>Reaction</th>
        <th>Recovery</th>
      </tr>
      {tmp}
  </Fragment>
    }
    var [frames, id] = computeRecovery(data,selectedMot);
    return <Fragment key="attackInfo">
          <tr className="alt"><th colSpan="2">Attack Info</th></tr>
          <tr><th>AttackFlags</th><td>{attackStr(selectedMot.attackFlags)}</td></tr>
          <tr><th>Startup</th><td>{selectedMot.startup}</td></tr>
          <tr><th>Active</th><td>{1+selectedMot.recovery-selectedMot.startup}</td></tr>
          <tr><th>Recovery</th><td>{frames-selectedMot.recovery}</td></tr>
          {
            hitEffects.map(hiteffectElement)
          }
        </Fragment>

  }

}



// WEBPACK FOOTER //
// ./src/AttackInfoPanel.js